// ErrorPage — общая страница ошибки с retry.
import { useState } from 'react';
import { Box, Typography, Button, Alert, Stack } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';

/** Страница ошибки с retry. */
export function ErrorPage(): JSX.Element {
  const [retrying, setRetrying] = useState(false);

  async function handleRetry(): Promise<void> {
    setRetrying(true);
    window.location.reload();
  }

  return (
    <Box
      sx={{
        minHeight: '60vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Stack spacing={2} alignItems="center" sx={{ textAlign: 'center', maxWidth: 480 }}>
        <Typography variant="h4" component="h1" sx={{ fontWeight: 500 }}>
          Произошла ошибка
        </Typography>
        <Alert severity="error" sx={{ width: '100%' }}>
          Не удалось загрузить запрашиваемый ресурс.
        </Alert>
        <Button
          variant="contained"
          onClick={() => void handleRetry()}
          startIcon={<RefreshIcon />}
          disabled={retrying}
        >
          Повторить
        </Button>
      </Stack>
    </Box>
  );
}
